let observer;

export default {
  intersected: {
    inserted: (el, binding) => {
      const defaultOptions = {
        rootMargin: '0px',
        threshold: 0.95,
      };

      observer = new IntersectionObserver(
        (entries, observ) => {
          binding.value.handler(entries, observ);
        },
        binding.value.options ?? defaultOptions,
      );
      observer.observe(el);
    },

    unbind: (el) => {
      observer.unobserve(el);
    },
  },
};
